import React from 'react';
import { connect } from "react-redux";
import { Button } from '../atoms/button';
import "./../../resources_membership_hotel/css/esthetic/restaurantList.css";

export const RestaurantAllList = (props) => {

    const { 
        facilityListWrapperName,
        planListWrapperName,
        planWrapperName,
        responsiveFlg,
        planListStyle,
        facilityImgStyle,
        handleReserve,
        handleErrorImage,
        onClickOpenPopupWindow,
        selectionList,
        loginFlg
    } = props;

    const userInfo = 
        <div style={planListStyle}>
            {selectionList.map((item, itemIndex) =>
                <div key={"hotel" + itemIndex} className="hotelSet">
                    <img
                        src={item.shisetsuImagePath}
                        className="hotelImage"
                        onError={e => {
                            e.target.parentElement.style.display = "none";
                            // handleErrorImage(item.shisetsuCd);
                        }}
                    />
                    <div className="hotelNameWrap" key={"hotelName" + itemIndex}>
                        <div className="membershipFacilityName">{item.shisetsuName}</div>
                    </div>
                    {item.restaurantList.map((restaurant, itemIndex2) =>
                        <div key={"restaurant" + itemIndex2} className="restaurantSet">
                            <img
                                src={restaurant.restaurantImagePath}
                                style={{ display: "none" }}
                                onError={e => { 
                                    e.target.parentElement.style.display = "none";
                                    // handleErrorImage(item.shisetsuCd, restaurant.restaurantCd);
                                }}
                            />
                            <div className="restaurantName">{restaurant.restaurantName}</div>
                            <div className="planSet">
                                <Button
                                    wrapClassName="planDetailWrapLong"
                                    className="planDetailBtn restaurantBtn"
                                    onClick={() => onClickOpenPopupWindow(item, restaurant)}
                                    buttonText={"レストラン詳細"}
                                    buttonClassName="serachBtnText"
                                    tabIndex="17"
                                />
                                <Button
                                    buttonText="予約する"
                                    className="btnReservationResult"
                                    onClick={() => handleReserve(itemIndex, itemIndex2)}
                                    buttonClassName="serachBtnText"
                                    tabIndex="18"
                                />
                            </div>
                        </div>
                    )}
                </div>
            )}
        </div >

    return (
        <>
            <div>{userInfo}</div>
        </>
    );
}

const mapStateToProps = (state) => {
    return {
        playDate1: state.playDate1,
    };
};
export default connect(mapStateToProps)(RestaurantAllList);
